import Component from './TwitterAnalyticsPublicFilter.vue'
export default Component
